export default __webpack_public_path__ + "static/media/mykommunity.7f98472c.jpg";